import { gql } from 'apollo-boost';
import { fetchGraphQL } from './graphQLservice'

export const saveSignatures = gql`
query ($sigInput:SignatureInputType){
    saveSignatures(sigInput:$sigInput)
    {
      responseCode
    }
  }
`;